export const LS_PREFIX = 'kofh5local_';

export const CONFIG = {
    domain: 'https://koa-activity.kingsgroupgames.com', // 域名
    publicPath: 'https://dkgt0qbrcw8cb.cloudfront.net/h5', // cdn
    apihost: 'https://koa-activity.kingsgroupgames.com/' // 接口域名
};

export const shareConfig = {
    title_en: [
        '20 Dragons, grab yours',
        'Help me win a Switch!',
        'Join battle dragon, win AirPods Pro'
    ],
    title_ru: [
        '20 драконов! Какой из них ваш?',
        'Помогите мне выиграть Switch!',
        'Сражайтесь на драконах и выиграйте AirPods Pro!'
    ],
    desc_en: [
        'Check out my Dragon! Adopt one and fight me!',
        "Everyone's playing this mini Dragon battling game! Come join!"
    ],
    desc_ru: [
        'Смотрите, какой у меня дракон! Выберите себе дракона и сразитесь со мной!',
        'Все играют в эту боевую мини-игру с драконами! Присоединяйтесь!'
    ],
    img: 'https://dkgt0qbrcw8cb.cloudfront.net/share_img.jpg'
};
